import React, { useState } from "react";
import addToMailchimp from "gatsby-plugin-mailchimp";

import classNames from "classnames/bind";
import styles from "./Newsletter.module.scss";

const Newsletter = ({className}) => {
    const [email, setEmail] = useState();
    const [message, setMessage] = useState();
    const [disabled, setDisabled] = useState(false);
    const [error, setError] = useState(false);

    const handleSubmit = async event => {
        event.preventDefault();
        setError(false);
        setDisabled(true);
        setMessage("Sending...");
        const response = await addToMailchimp(email);

        if (response.result === "error") {
            if (response.msg.toLowerCase().includes("already subscribed")) {
                setMessage("You're already on to the list!");
            } else {
                setError(true);
                setMessage("Some error occured while subscribing you to the list.");
            }
            setDisabled(false)
        } else {
            setMessage(
                "Thanks! Please check your e-mail and click the confirmation link."
            )
        }
    };

    const cx = classNames.bind(styles);

    const classes = cx(
        "wrapper",
        className
    );

    return (
        <div className={classes}>
            <h4
                className={styles.title}
            >
                Keep in touch
            </h4>
            <p
                className={styles.subtitle}
            >
                I send occassional emails with exclusive content
            </p>
            <form
                className={cx("form", {"error" : error})}
                onSubmit={handleSubmit}
            >
                <input
                    className={styles.input}
                    aria-label="Email address"
                    onChange={event => setEmail(event.target.value)}
                    placeholder="Enter your email"
                    required
                    type="email"
                />
                <div>
                    <input
                        className={styles.button}
                        type="submit" 
                        disabled={disabled} 
                    />
                </div>
            </form>
            <div className={cx("message", {"error" : error})}>
                {message}
            </div>
        </div>
    )
}
        
export default Newsletter;